import config from "../../config/app.config";
import constants from "../constants";
import axios from "axios";
import moment from "moment";

import presentData from "../assets/presets.json";
import trackerOverview from "../assets/trackers/overview.json";
import metricwireDeventer from "../assets/metricwire/deventer/surveys.json";
import vrResultsDeventer from "../assets/vr/deventer/vr-results.json";

/*Antea*/
import anteaMeasurements from "../assets/antea/overview.json";
import * as deventerEvents from "@/assets/events/uitagenda-deventer-2019.json";
import * as amersfoortEvents from "@/assets/events/uitagenda-amersfoort-2018-2019.json";

const EVENTS_MAPPING_ENTITY_DATASOURCE = {
  amersfoort: amersfoortEvents.map((ev, ix) => {
    return {
      ...ev,
      id: ix,
      start: moment(ev.startdatum, "DD-MM-YYYY HH:mm"),
      end: moment(ev.einddatum, "DD-MM-YYYY HH:mm")
    };
  }),
  deventer: deventerEvents.map((ev, ix) => {
    return {
      ...ev,
      id: ix,
      start: moment(ev.startdatum, "DD-MM-YYYY HH:mm"),
      end: moment(ev.einddatum, "DD-MM-YYYY HH:mm")
    };
  })
};

//TODO Read this from Orion, this is a silly thing
const PARKING_ENTITY_DATASOURCE = {
  deventer: [
    "45434989-3252-4c85-8731-c856b02c390c",
    "186af3cc-3ebe-40b1-a807-72f98dbc94f7",
    "e3b7e292-ef14-43c9-96fb-85ab7b08ef09",
    "4d958ee5-ca22-4cf1-9568-7b3aafa4350e",
    "4639a30f-a31e-4f72-8430-49c1d8ff6be7",
    "5829fb06-ee4a-4762-946c-ed6209edf7d5",
    "9939a414-628f-4b60-8068-f7731ea5f31a",
    "0e8a6857-655d-467b-8c15-8ee65c7357bf",
    "8d85bbdb-8bbd-4a24-b35f-85f21186ec04"
  ]
};

export default {
  /* Events */
  fetchEvents: context => {
    const selectedLocation =
      context.state.navigation.tabs[context.state.navigation.activeTabIndex];
    const key = selectedLocation.name.toLowerCase();
    const dataSource = EVENTS_MAPPING_ENTITY_DATASOURCE[key];
    const filterStart = context.state.data.filter.startDate;
    const filterEnd = context.state.data.filter.endDate;
    if (dataSource && filterStart && filterEnd) {
      const start = moment(filterStart);
      const end = moment(filterEnd);
      const events = dataSource.filter(
        ev => ev.start.isSameOrAfter(start) && ev.end.isBefore(end)
      );
      // console.log(JSON.stringify(events, null, 2));
      // Transform data to GeoJSON FeatureCollection
      const features = [];
      for (var i = 0; i < events.length; i++) {
        const feature = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [events[i].lng, events[i].lat]
          },
          properties: {
            id: events[i].id,
            name: events[i].naam.replace(/['"]+/g, ""),
            locatie: events[i].locatie,
            startdatum: events[i].start.format("YYYY-MM-DD"),
            einddatum: events[i].end.format("YYYY-MM-DD"),
            selected: false
          }
        };
        features.push(feature);
      }
      let fc = {
        type: "FeatureCollection",
        features: features
      };
      context.commit("setDataEventsCollectionFeatures", fc);
    }
  },
  /* Weather */
  fetchCurrentWeather: (context, location) => {
    const URL = config.orionBaseUrl + `entities?q=name==${location.location}`;

    // Do API query call
    axios
      .get(URL, {
        headers: {
          "Fiware-Service": "WeatherService",
          "Fiware-Servicepath": "/nl"
        }
      })
      .then(response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let currentWeather = {
              temperature: Math.round(response.data[0].temperature.value),
              icon: response.data[0].owmWeatherIcon.value
            };
            context.commit("setDataCurrentWeather", currentWeather);
          }
        }
      });
  },
  appendUserPresets: (state, payload) => {
    let location = payload.location;
    let presetObject = {
      id:
        location +
        "." +
        payload.startDate.replace("-", "") +
        "." +
        payload.endDate.replace("-", ""),
      name: payload.name,
      filter: {
        startDate: payload.startDate,
        endDate: payload.endDate
      }
    };

    let presets = state.getters.dataFilterUserPresets;
    presets.push(presetObject);
    state.commit("setUserPresets", presets);

    // Localstorage komt later
    // let presetLabel = location.toLowerCase()+"_preset"
    // if(localStorage[presetLabel]){
    //   try{
    //     let presets = JSON.parse(localStorage[presetLabel])
    //     presets.push(presetObject)
    //     localStorage[presetLabel] = JSON.stringify(presets)
    //   }catch(e){
    //     console.log(e)
    //   }
    // }
  },
  fetchWeatherOnDate: (context, payload) => {
    const onDate = moment(payload.onDate).toISOString();
    const entityId = `nl-${payload.location.toLocaleString()}`;
    let params = {
      sql: `SELECT time_index, temperature, owmweathericon 
           FROM mtweatherservice.etweatherobserved  
           WHERE entity_id = '${entityId}' 
           AND time_index < '${onDate}' 
           LIMIT 1;`
    };
    const callConfig = {
      auth: config.postgresAuth
    };

    // Do API query call
    axios.post(config.sqlConduitUrl, params, callConfig).then(response => {
      if (response.status === 200) {
        let currentWeather = {};
        for (const row of response.data.rows) {
          currentWeather.temperature = Math.round(row.temperature);
          currentWeather.icon = row.owmweathericon;
        }
        context.commit("setDataCurrentWeather", currentWeather);
      } else {
        // eslint-disable-next-line
        console.log("Error connecting to SQLConduit");
      }
    });
  },
  fetchWeatherTimeSeries: (context, payload) => {
    const startDate = payload.startDate;
    const endDate = payload.endDate;
    const entityId = `nl-${payload.location.toLocaleString()}`;
    let params = {
      sql: `SELECT date_trunc('hour', time_index) as hour, 
            AVG(temperature) AS avg_temperature 
           FROM mtweatherservice.etweatherobserved  
           WHERE entity_id = '${entityId}' 
           AND time_index > '${startDate}' 
           AND time_index < '${endDate}' 
           GROUP BY date_trunc('hour', time_index)
           ORDER BY date_trunc('hour', time_index);`
    };
    const callConfig = {
      auth: config.postgresAuth
    };

    // Do API query call
    axios.post(config.sqlConduitUrl, params, callConfig).then(response => {
      if (response.status === 200) {
        const chartLabels = [];
        const chartDataset = [];
        for (const row of response.data.rows) {
          chartLabels.push(row.hour);
          chartDataset.push(Number(row.avg_temperature).toFixed(2));
        }
        let weatherData = {
          labels: chartLabels,
          datasets: [
            {
              label: "Weer",
              fill: false,
              backgroundColor: "rgba(246, 194, 44, 0.8)",
              data: chartDataset
            }
          ]
        };
        context.commit("setDataWeatherTimeSeries", weatherData);
      } else {
        // eslint-disable-next-line
        console.log("Error connecting to SQLConduit");
      }
    });
  },
  /* Parking */
  fetchParkingPlaces: context => {
    // Build url for geospatial query
    let bbox = context.state.map.bounds;
    const URL =
      config.orionBaseUrl +
      `entities?georel=coveredBy&geometry=box&coords=` +
      bbox.ne.lat +
      `,` +
      bbox.ne.lng +
      `;` +
      bbox.sw.lat +
      `,` +
      bbox.sw.lng;

    // Do API query call
    axios
      .get(URL, {
        headers: {
          "Fiware-Service": "ParkingService",
          "Fiware-Servicepath": "/nl"
        }
      })
      .then(response => {
        if (response.status === 200) {
          // console.log('Fetch parking: ', response.data);
          var features = [];
          for (var i = 0; i < response.data.length; i++) {
            var name = "Onbekend";
            if (response.data[i].description) {
              name = response.data[i].description.value;
            }
            const feature = {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: response.data[i].location.value.coordinates
              },
              properties: {
                name: name,
                entityId: response.data[i].id,
                availableSpots: response.data[i].availableSpotNumber.value,
                totalSpots: response.data[i].totalSpotNumber.value,
                occupiedSpots:
                  response.data[i].totalSpotNumber.value -
                  response.data[i].availableSpotNumber.value,
                occupiedPercentage: Math.round(
                  ((response.data[i].totalSpotNumber.value -
                    response.data[i].availableSpotNumber.value) /
                    response.data[i].totalSpotNumber.value) *
                    100
                )
              }
            };
            features.push(feature);
          }
          let fc = {
            type: "FeatureCollection",
            features: features
          };
          context.commit("setDataParkingCollectionFeatures", fc);
          context.commit("setMapDataUpdate", true);
        } else {
          // eslint-disable-next-line no-console
          console.log("Error fetching parking");
        }
      });
  },
  fetchParkingPlacesByLocation: (context, location) => {
    const URL =
      config.orionBaseUrl + `entities?q=address.addressLocality==` + location;
    // console.log('Fetch parking (loc): ', URL);

    // Do API query call
    axios
      .get(URL, {
        headers: {
          "Fiware-Service": "ParkingService",
          "Fiware-Servicepath": "/nl"
        }
      })
      .then(response => {
        if (response.status === 200) {
          // console.log('Fetch parking (loc) Resp: ', response.data);
          var features = [];
          for (var i = 0; i < response.data.length; i++) {
            var name = "Onbekend";
            if (response.data[i].description) {
              name = response.data[i].description.value;
            }
            const feature = {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: response.data[i].location.value.coordinates
              },
              properties: {
                name: name,
                entityId: response.data[i].id,
                availableSpots: response.data[i].availableSpotNumber.value,
                totalSpots: response.data[i].totalSpotNumber.value,
                occupiedSpots:
                  response.data[i].totalSpotNumber.value -
                  response.data[i].availableSpotNumber.value,
                occupiedPercentage: Math.round(
                  ((response.data[i].totalSpotNumber.value -
                    response.data[i].availableSpotNumber.value) /
                    response.data[i].totalSpotNumber.value) *
                    100
                )
              }
            };
            features.push(feature);
          }
          let fc = {
            type: "FeatureCollection",
            features: features
          };
          context.commit("setDataParkingCollectionFeatures", fc);
          context.commit("setMapDataUpdate", true);
        } else {
          // eslint-disable-next-line no-console
          console.log("Error fetching parking");
        }
      });
  },
  fetchParkingTimeSeries: (context, payload) => {
    let mapping = PARKING_ENTITY_DATASOURCE[payload.location.toLowerCase()];
    if (mapping) {
      // Create a promise for every parking garage
      let promiseArray = [];
      for (const entityId of mapping) {
        promiseArray.push(
          internalFetchParking({
            ...payload,
            entityId: entityId
          })
        );
      }
      // Wait until all promises resolve.
      Promise.all(promiseArray).then(function(datasets) {
        let tmp = {};
        for (let i = 0, len = datasets.length; i < len; i++) {
          // const entityId = datasets[i].entityId
          const labels = datasets[i].chartData.labels;
          const chartDatasets = datasets[i].chartData.datasets;

          for (let j = 0; j < labels.length; j++) {
            let value = chartDatasets[0].data[j];
            if (isNaN(tmp[labels[j]])) {
              tmp[labels[j]] = 0;
            }
            if (!isNaN(parseInt(value))) {
              tmp[labels[j]] += parseInt(value);
            }
          }
          // Commit to store.
          context.commit("setParkingChartData", datasets[i]);
        }
        // Convert tmp to chart data format.
        const chartLabels = [];
        const chartDataset = [];
        for (let i = 0, keys = Object.keys(tmp); i < keys.length; i++) {
          chartLabels.push(keys[i]);
          chartDataset.push(tmp[keys[i]]);
        }
        context.commit("setDataParkingTimeSeries", {
          labels: chartLabels,
          datasets: [
            {
              label: "Parkeer",
              backgroundColor: "rgba(54, 118, 217, 0.8)",
              fill: false,
              data: chartDataset
            }
          ]
        });
      });
    }
  },
  fetchParkingContext: (context, payload) => {
    internalFetchParking(payload).then(result =>
      context.commit("setParkingChartData", result)
    );
  },
  /* Travel Time and Intensity */
  fetchTrafficIntensity: context => {
    const URL = config.orionBaseUrl + `entities?q=city==Deventer`;
    // console.log('Fetch travel intensity: ', URL)
    // Do API query call
    axios
      .get(URL, {
        headers: { "Fiware-Service": "VLogService", "Fiware-Servicepath": "/" }
      })
      .then(response => {
        if (response.status === 200) {
          let features = [];
          for (let i = 0, len = response.data.length; i < len; i++) {
            const feature = {
              type: "Feature",
              id: response.data[i].id,
              geometry: response.data[i].location.value,
              properties: {
                description: response.data[i].description.value,
                detectionCount: response.data[i].detectionCount.value,
                eventCount: response.data[i].eventCount.value,
                buttonPushes_FTS: response.data[i].buttonPushes_FTS
                  ? response.data[i].buttonPushes_FTS.value
                  : 0,
                buttonPushes_VTG: response.data[i].buttonPushes_VTG
                  ? response.data[i].buttonPushes_VTG.value
                  : 0,
                passages_MVT: response.data[i].passages_MVT
                  ? response.data[i].passages_MVT.value
                  : 0,
                passages_OV: response.data[i].passages_OV
                  ? response.data[i].passages_OV.value
                  : 0,
                passages_FTS: response.data[i].passages_FTS
                  ? response.data[i].passages_FTS.value
                  : 0
              }
            };
            features.push(feature);
          }
          let fc = {
            type: "FeatureCollection",
            features: features
          };
          context.commit("setDataTrafficIntensityTimeseries", fc);
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  fetchTravelIntensityTimeSeries: (context, payload) => {
    // Fetch historical data from Postgres/Timescale
    const filterStart = context.state.data.filter.startDate;
    const filterEnd = context.state.data.filter.endDate;
    let params = {
      sql: `SELECT entity_id, date_trunc('hour', time_index) as hour, 
            SUM(eventcount) AS sum_eventcount
           FROM mtvlogservice.ettrafficintensitytype 
           WHERE time_index > '${filterStart}' 
           AND time_index < '${filterEnd}' 
           GROUP BY entity_id, date_trunc('hour', time_index) 
           ORDER BY entity_id, date_trunc('hour', time_index);`
      // Don't do all these, we don't need it.
      // SUM(buttonpushes_fts) AS sum_buttonpushes_fts,
      // SUM(buttonpushes_vtg) AS sum_buttonpushes_vtg,
      // SUM(passages_fts) AS sum_passages_fts,
      // SUM(passages_mvt) AS sum_passages_mvt
    };
    const callConfig = {
      auth: config.postgresAuth
    };
    axios.post(config.sqlConduitUrl, params, callConfig).then(response => {
      if (response.status === 200) {
        // console.log(response.data)
        let timeseries = {};
        for (const row of response.data.rows) {
          if (!timeseries[row.hour]) {
            timeseries[row.hour] = [];
          }
          timeseries[row.hour].push({
            id: row.entity_id,
            properties: {
              eventCount: row.sum_eventcount
            }
          });
        }
        // console.log(timeseries)
        context.commit("setTravelIntensityTimeSeries", timeseries);
      } else {
        // eslint-disable-next-line no-console
        console.log("Error connecting to SQLConduit for traffic intensity");
      }
    });
  },
  fetchTravelTime: context => {
    const URL = config.orionBaseUrl + `entities?q=city==Deventer`;
    // console.log('Fetch travel time: ', URL);

    // Do API query call
    axios
      .get(URL, {
        headers: {
          "Fiware-Service": "TravelTimeService",
          "Fiware-Servicepath": "/"
        }
      })
      .then(response => {
        if (response.status === 200) {
          // console.log('Fetch travel time: ', response.data);
          for (let i = 0, len = response.data.length; i < len; i++) {
            let travelTime = {
              urn: response.data[i].id,
              relativeDelay: response.data[i].relativeDelay.value,
              referencetravelTime: response.data[i].referencetravelTime.value,
              travelTime: response.data[i].travelTime.value
            };
            context.commit("setTravelTime", travelTime);
          }
        }
      });
  },
  // eslint-disable-next-line no-unused-vars
  fetchTravelTimeTimeSeries: (context, payload) => {
    const filterStart = context.state.data.filter.startDate;
    const filterEnd = context.state.data.filter.endDate;
    const entityIds = Object.keys(constants.TRAVELTIME_SHAPES_MAPPING);
    const city =
      context.state.navigation.tabs[context.state.navigation.activeTabIndex]
        .name;
    const entityList = entityIds.map(e => `'${e}'`).join(", ");
    let params = {
      sql: `SELECT entity_id, date_trunc('hour', time_index) as timeinstant, 
              AVG(relativedelay) AS avg_relativedelay 
             FROM mttraveltimeservice.ettraveltimetype 
             WHERE entity_id IN (${entityList}) 
             AND time_index >= '${filterStart}' 
             AND time_index < '${filterEnd}' 
             GROUP BY entity_id, date_trunc('hour', time_index)  
             ORDER BY entity_id, date_trunc('hour', time_index);`
    };
    const callConfig = {
      auth: config.postgresAuth
    };
    axios
      .post(config.sqlConduitUrl, params, callConfig)
      .then(rsp => {
        if (rsp.status === 200) {
          const timeseries = {};
          for (const row of rsp.data.rows) {
            if (!timeseries[row.timeinstant]) {
              timeseries[row.timeinstant] = [];
            }
            timeseries[row.timeinstant].push({
              urn: row.entity_id,
              relativeDelay: row.avg_relativedelay
            });
          }
          // console.log(timeseries)
          context.commit("setTravelTimeTimeSeries", timeseries);
        }
      })
      .catch(err => {
        //eslint-disable-next-line no-console
        console.error(
          `Error fetching TravelTime TimeSeries (${city}, ${filterStart}, ${filterEnd}): ${err}`
        );
      });
  },
  /* VR */
  // eslint-disable-next-line no-unused-vars
  fetchVrResults: (context, payload) => {
    const selectedLocation =
      context.state.navigation.tabs[context.state.navigation.activeTabIndex];
    const filterStart = context.state.data.filter.startDate.replace(/-/g, "");
    const filterEnd = context.state.data.filter.endDate.replace(/-/g, "");

    if (selectedLocation.name.toLowerCase() === "deventer") {
      let surveys = vrResultsDeventer.surveys;
      for (let i = 0; i < surveys.length; i++) {
        let surveyDate = moment(surveys[i].date);
        // console.log(moment(filterStart).isSameOrBefore(surveyDate) + ' - ' + moment(filterEnd).isSameOrAfter(surveyDate))
        if (
          moment(filterStart).isSameOrBefore(surveyDate) &&
          moment(filterEnd).isSameOrAfter(surveyDate)
        ) {
          // console.log(surveys[i])
          // Set in store.
        }
      }
    }
  },
  /* Antea */
  fetchAntea: context => {
    // const selectedLocation = context.state.navigation.tabs[context.state.navigation.activeTabIndex]
    const filterStart = context.state.data.filter.startDate.replace(/-/g, "");
    // const filterEnd = context.state.data.filter.endDate.replace(/-/g, '')

    let fijnstof = undefined;
    let ultrafijnstof = undefined;
    let trillingen = undefined;
    let thies = undefined;
    // let MeasurementDates = Object.keys(anteaMeasurements)

    //TODO: zorg dat de datum check net zo gaat werken als bij de trackers!
    if (anteaMeasurements[filterStart] !== undefined) {
      let fijnstofSource = anteaMeasurements[filterStart].fijnstof;
      if (fijnstofSource) {
        let fijnstofRaw = require("../assets/" + fijnstofSource);
        let avgSets = [];
        let labelSet = [];

        let hoursets = fijnstofRaw.reduce(
          function(acc, d) {
            let p = d.datetime.substring(11, 13);
            if (!acc[0].hasOwnProperty(p)) acc[0][p] = [];
            acc[0][p].push(d);
            return acc;
          },
          [{}]
        );
        for (const [key, value] of Object.entries(hoursets[0])) {
          labelSet.push(key);
          let hourset = value;
          let sum = hourset.reduce(function(acc, d) {
            return acc + d["Small_particles"];
          }, 0);
          avgSets.push(sum / hourset.length);
        }
        fijnstof = {
          labels: labelSet,
          datasets: [
            {
              label: "Fijne deeltjes",
              data: avgSets,
              fill: false,
              borderColor: "#2196f3"
            }
          ]
        };
      }
      let ultrafijnstofSource = anteaMeasurements[filterStart].ultrafijnstof;

      if (ultrafijnstofSource) {
        let ultrafijnstofRaw = require("../assets/" + ultrafijnstofSource);
        let avgSets = [];
        let labelSet = [];

        let hoursets = ultrafijnstofRaw.reduce(
          function(acc, d) {
            let p = d.datetime.substring(11, 13);
            if (!acc[0].hasOwnProperty(p)) acc[0][p] = [];
            acc[0][p].push(d);
            return acc;
          },
          [{}]
        );
        for (const [key, value] of Object.entries(hoursets[0])) {
          labelSet.push(key);
          let hourset = value;
          let sum = hourset.reduce(function(acc, d) {
            return acc + d["CalculatedN"];
          }, 0);
          avgSets.push(sum / hourset.length);
        }
        ultrafijnstof = {
          labels: labelSet,
          datasets: [
            {
              label: "Calculated N",
              data: avgSets,
              fill: false,
              borderColor: "#2196f3"
            }
          ]
        };
      }
      let trillingenSource = anteaMeasurements[filterStart].trillingen;
      if (trillingenSource) {
        let trillingenRaw = require("../assets/" + trillingenSource);
        let avgSets = [];
        let labelSet = [];

        let hoursets = trillingenRaw.reduce(
          function(acc, d) {
            let p = d.datetime.substring(11, 13);
            if (!acc[0].hasOwnProperty(p)) acc[0][p] = [];
            acc[0][p].push(d);
            return acc;
          },
          [{}]
        );
        for (const [key, value] of Object.entries(hoursets[0])) {
          labelSet.push(key);
          let hourset = value;
          let sum = hourset.reduce(function(acc, d) {
            return acc + d["kbfmaxY"];
          }, 0);
          avgSets.push(sum / hourset.length);
        }
        trillingen = {
          labels: labelSet,
          datasets: [
            {
              label: "Trillingen",
              data: avgSets,
              fill: false,
              borderColor: "#2196f3"
            }
          ]
        };
      }
      let thiesSource = anteaMeasurements[filterStart].thies;
      if (thiesSource) {
        let thiesRaw = require("../assets/" + thiesSource);
        // let trillingenRaw = require('../assets/'+trillingenSource)
        let avgSets = [];
        let labelSet = [];

        let hoursets = thiesRaw.reduce(
          function(acc, d) {
            let p = d.datetime.substring(11, 13);
            if (!acc[0].hasOwnProperty(p)) acc[0][p] = [];
            acc[0][p].push(d);
            return acc;
          },
          [{}]
        );
        for (const [key, value] of Object.entries(hoursets[0])) {
          labelSet.push(key);
          let hourset = value;
          let sum = hourset.reduce(function(acc, d) {
            return acc + d["airtemperature"];
          }, 0);
          avgSets.push(sum / hourset.length);
        }
        thies = {
          labels: labelSet,
          datasets: [
            {
              label: "Lucht temperatuur",
              data: avgSets,
              fill: false,
              borderColor: "#2196f3"
            }
          ]
        };
      }

      const payload = {
        fijnstof: fijnstof,
        ultrafijnstof: ultrafijnstof,
        trillingen: trillingen,
        thies: thies
      };
      // console.log('payload',payload)
      context.commit("setAnteaData", payload);
    }
  },
  /* Trackers */
  fetchTrackers: context => {
    // const selectedLocation = context.state.navigation.tabs[context.state.navigation.activeTabIndex]
    const filterStart = context.state.data.filter.startDate.replace(/-/g, "");
    const filterEnd = context.state.data.filter.endDate.replace(/-/g, "");
    let trackerDates = Object.keys(trackerOverview);
    let trackerLikes = undefined;
    let trackerData = undefined;
    for (let i = 0, len = trackerDates.length; i < len; i++) {
      if (filterStart <= trackerDates[i] && filterEnd >= trackerDates[i]) {
        let source = trackerOverview[trackerDates[i]].source;
        trackerData = require("../assets/" + source);
        let likePath = trackerOverview[trackerDates[i]].likes;
        if (likePath) {
          trackerLikes = require("../assets/" + likePath);
        }
      }
    }
    if (trackerData) {
      let trackers = transformRoutesToFeatureCollection(trackerData);
      context.commit("setDataTrackerHeatmapCollectionFeatures", trackers.fc);

      let fcs = transformRoutesToFeatureCollectionCollection(trackers.routes);
      context.commit("setDataTrackerRoutesCollectionFeatures", fcs);
    }
    if (trackerLikes) {
      // console.log(trackerLikes)
      context.commit("setDataTrackerLikes", trackerLikes);
    }
  },
  /* Presets */
  fetchPresets: (context, location) => {
    //TODO: Store presets in some backend.
    let presets = presentData.presets[location.toLowerCase()];
    if (!presets) presets = [];
    context.commit("setPresets", presets);
  },
  /* Experience sampling */
  fetchSurveys: (context, { location }) => {
    if (location.toLowerCase() === "deventer") {
      let surveys = metricwireDeventer.surveys;
      // console.log(surveys)
      context.commit("setDataMetricWireSurveys", surveys);
    }
  },
  setSelectedSurvey: (context, name) => {
    // console.log('setSelectedSurvey: ', name)
    // Mapping van naam naar selected survey
    const MAPPING = {
      "Algemeen binnenstad": ["Algemeen binnenstad"],
      "Grote Kerkhof": ["Grote Kerkhof - Overdag", "Grote Kerkhof - 's Avonds"],
      Stromarkt: ["Stromarkt"],
      Brink: [
        "Brink - Overdag",
        "Brink - Marktdagen",
        "Brink - Avond",
        "Brink - Uitgaan"
      ],
      Lange: ["Lange Bisschopstraat"],
      "Overige Winkelstraten (1)": ["Kleine Overstraat", "Grote Overstraat"],
      "Overige Winkelstraten (2)": ["Nieuwstraat"],
      "Overige Winkelstraten (3)": ["Walstraat", "Boreelplein"]
    };
    context.commit("setDataMetricWireSurveyCategories", []);

    if (MAPPING[name]) {
      let result = [];
      for (let i = 0; i < MAPPING[name].length; i++) {
        result.push(
          context.state.data.metricwire.surveys.find(
            s => s.name === MAPPING[name][i]
          )
        );
      }
      // console.log(result)
      if (result.length > 1) {
        context.commit("setDataMetricWireSurveyCategories", result);
      }
      let dataset = require(`../assets/metricwire/deventer/submissions/${result[0].id}.json`);
      context.commit("setDataMetricWireSelectedSurvey", dataset);
    }
  },
  fetchSurveysSubmissions: (context, survey) => {
    let workspaceId = survey.workspaceId;
    let studyId = survey.studyId;
    let surveyId = survey.id;

    let token =
      context.state.data.experienceSampling.authToken ||
      process.env.VUE_APP_MW_TOKEN;
    if (token) {
      // Do API query call
      const URL = `${config.metricwireBaseUrl}/submissions/${workspaceId}/${studyId}/${surveyId}`;
      axios
        .get(URL, { headers: { Authorization: "Bearer " + token } })
        .then(response => {
          if (response.status === 200) {
            let questions = [];
            let numQuestions = Object.keys(response.data.surveyMeta);
            for (let i = 0; i < numQuestions.length; i++) {
              questions.push({
                id: response.data.surveyMeta[numQuestions[i]].id,
                label: response.data.surveyMeta[numQuestions[i]].question,
                choices: response.data.surveyMeta[numQuestions[i]].choices,
                selected: i === 0
              });
            }
            context.commit("setExperienceSamplingQuestions", questions);

            // Select first question.
            let choices = questions[0].choices;
            let name =
              response.data.studyName + " - " + response.data.surveyName;
            let data = [];
            for (let j = 0; j < choices.length; j++) {
              data.push(0);
            }
            for (let p = 0; p < response.data.submissions.length; p++) {
              let submission = response.data.submissions[p];
              let answer = submission.questionValues[questions[0].id];
              for (let q = 0; q < choices.length; q++) {
                if (choices[q] === answer.response) {
                  let newValue = data[q] + 1;
                  data.splice(q, 1, newValue);
                  break;
                }
              }
            }
            let chart = {
              name: name,
              labels: choices,
              data: data
            };
            context.commit("setExperienceSamplingSurveyChart", chart);
            context.commit("setExperienceSamplingSelectedQuestion", {
              questionId: questions[0].id
            });
          }
        });
    }
  }
};

function transformRoutesToFeatureCollection(data) {
  let features = [];
  let routesIds = [];
  for (let i = 0; i < data.features.length; i++) {
    const coordinates = data.features[i].geometry.coordinates;

    features.push({
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: coordinates
      },
      properties: {
        weight: 10
      }
    });
    // Build the route id collection for post processing.
    const uitgifte_id = data.features[i].properties.uitgifte_id;
    const timestamp = moment(data.features[i].properties.timestamp);
    if (!routesIds[uitgifte_id]) {
      routesIds[uitgifte_id] = [];
    }
    routesIds[uitgifte_id].push({
      properties: {
        location: coordinates,
        timestamp: timestamp.utc().format("X"),
        uitgifte_id: uitgifte_id
      }
    });
  }
  let fc = {
    type: "FeatureCollection",
    features: features
  };
  return {
    fc: fc,
    routes: routesIds
  };
}

function transformRoutesToFeatureCollectionCollection(routes) {
  // Create feature FeatureCollection for the (sorted) list of routes
  let fcs = [];
  for (let i = 0; i < routes.length; i++) {
    if (routes[i]) {
      const sortedRoutes = routes[i].sort(
        (a, b) => a.properties.timestamp - b.properties.timestamp
      );
      let points = [];
      for (let j = 0; j < sortedRoutes.length; j++) {
        points.push(sortedRoutes[j].properties.location);
      }
      fcs.push({
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: points
            },
            properties: {}
          }
        ]
      });
    }
  }
  return fcs;
}

function internalFetchParking(payload) {
  return new Promise((resolve, reject) => {
    const startDate = payload.startDate;
    const endDate = payload.endDate;
    const nameParking = payload.nameParking;
    const params = {
      sql: `SELECT entity_id, date_trunc('hour', time_index) as time_index, AVG(availablespotnumber) AS avg_avail, AVG(totalspotnumber) AS avg_total 
           FROM mtparkingservice.etoffstreetparking 
           WHERE entity_id = '${payload.entityId}'
           AND time_index > '${startDate}' 
           AND time_index < '${endDate}' 
           GROUP BY entity_id, date_trunc('hour', time_index) 
           ORDER BY entity_id, date_trunc('hour', time_index);`
    };
    const callConfig = {
      auth: config.postgresAuth
    };
    axios.post(config.sqlConduitUrl, params, callConfig).then(rsp => {
      if (rsp.status === 200) {
        const chartLabels = [];
        const chartDataset = [];
        rsp.data.rows.forEach(row => {
          chartLabels.push(row.time_index);
          chartDataset.push(row.avg_avail);
        });
        const parkingChartData = {
          labels: chartLabels,
          datasets: [
            {
              label: nameParking,
              fill: false,
              backgroundColor: "rgba(54, 118, 217, 0.8)",
              data: chartDataset
            }
          ]
        };
        resolve({
          entityId: payload.entityId,
          chartData: parkingChartData
        });
      } else {
        reject("Error connecting to SQLConduit for parking");
      }
    });
  });
}
